import { PinInput, PinInputProps } from '@mantine/core';

import classes from './PinInput.module.css';

const PinInputDefaults = PinInput.extend({
  classNames: { input: classes.input, pinInput: classes.pinInput },
});

export { PinInput, PinInputDefaults };
export type { PinInputProps };
